module.exports = __webpack_public_path__ + "static/media/knauf-logo-color.6d14b788.svg";